import React, { Fragment } from "react";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import LiveChat from "../LiveChat";
import RequestItem from "../../components/RequestItem";
import TicketDetailModal from "../../components/TicketDetailModal";
import HexHover from "../../components/HexHover";
import user_avatar from "../../assets/media/user.png";
import chat_png from "../../assets/media/chat.png";
import ScheduleModal from "../CalendarHub/ScheduleModal";
import AddNoteModal from "../../components/AddNoteModal";
import ManifestModal from "../Users/ManifestModal";
import SelectUserModal from "../ChatSuite/SelectUserModal";
import PDFViewerModal from "../../components/PDFViewer";
import moment from "moment";
import { alertAppointment } from "../../functions/Twilio";
import { getDayStr } from "../../functions";
import "./index.css";

class SuperChatSuite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
      selectedBrand: null,
      request_arr: [],
      selected: false, // TODO: is this the same as selectedUser?
      request: "",
      chatdiv_visible: false,
      request_status: [],
      room_id: "",
      loadingBrands: true,
      loadingUsers: false,
      selectedUser: null,
      fullUserUpgrade: false, // TODO: is this used?
      selectedPDF: null,
      users: [], // TODO: is this used and should I avoid fetching all users?
      brand_tasks: [],
      ticketIssues: [],
      upcomingTask: false,
    };
    this.manifestModalRef = React.createRef();
  }
  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { role, username } = this.props.location.state;
      this.setState({ username, role, loadingBrands: true });
      Firebase.getAllBrands((res) => {
        let brands = res
          .map((item, index) => {
            let new_item = item;
            new_item.id = index;
            return new_item;
          })
          .filter((item) => item && !item.deactive);
        brands.sort(function (a, b) {
          var textA = a.name.toUpperCase();
          var textB = b.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

        if (localStorage.getItem("umbrella")) {
          const umbrellaBrand = Number(localStorage.getItem("umbrella"));
          brands = brands.filter((obj) => obj.parent === umbrellaBrand);
        }
        this.setState({ brands, loadingBrands: false });
      });

      // Firebase.getAllBrandsOnce((brands) =>
      // });
      // Firebase.getAllBrandsOnce((brands) => {
      //   let counts = 0;
      //   brands.forEach((brand) => {
      //     Firebase.getAllUsersInBrand(brand.name).then((users) => {
      //       const demoUser = users.find((user) => user.isDemo);
      //       if (demoUser) {
      //         Firebase.addLiveChat(demoUser.id, {
      //           brand: brand.name,
      //           tickets: {
      //             "12": {
      //               adjective: "Cold",
      //               band: "urgent issue",
      //               contractor_id: "OBSvq2HxehOudbuyk73bMJsxcSo1",
      //               contractor_typing: false,
      //               issue: "Immersion Heater ",
      //               item: "Shower Water",
      //               repair_sla: "within 3 working hours",
      //               response_sla: "within 1 hour",
      //               room: "Bathroom",
      //               status: "Open",
      //               ticket_id: 1.2,
      //               time: "1594919605967",
      //               title: "Home Repairs",
      //               content: {},
      //             },
      //           },
      //           isDemo: true,
      //           uid: demoUser.id,
      //           username: demoUser.firstname,
      //         })
      //           .then(() => {
      //             counts += 1;
      //             console.log(counts, "success");
      //           })
      //           .catch(() => {
      //             console.log("error", brand);
      //           });
      //       } else {
      //         console.log(counts, "no user", brand);
      //       }
      //     });
      //   });
      // });
    }
  }

  async componentDidUpdate(_prevProps, prevState) {
    if (this.state.selectedBrand !== prevState.selectedBrand) {
      const { selectedBrand, brands } = this.state;
      const brand = (brands || []).find(
        (item) => item.id === selectedBrand.value
      );

      if (brand) {
        this.setState({ loadingUsers: true });

        const sectors = await Firebase.getAllSectors();

        Firebase.getBrandDataByID(brand.id, (brand_data) => {
          this.setState({
            categories: brand_data.userCategories || [],
            brand_data: brand_data,
            icon: brand_data.icon,
            brand_name: brand_data.name,
            brand_url: brand_data.url,
            hex: brand_data.hex,
            loadingUsers: false,
            is_property_brand: brand_data.is_property_brand
              ? brand_data.is_property_brand
              : false,
          });
          Firebase.getAllTasksRunningByBrand(
            brand_data.name,
            this.subscribeTasks
          );

          const { sector } = brand_data;
          if (sector) {
            const sectorData = sectors[sector];
            const { ticket_types } = sectorData;
            if (ticket_types) this.setState({ ticketTypes: ticket_types });
          }
        });

        Firebase.getAllTicketIssues((ticketIssues) => {
          this.setState({ ticketIssues });
        });

        Firebase.getTicketByBrandID(brand.id, (res) => {
          if (res) {
            const request_arr = Object.values(res);
            request_arr.forEach((item) => {
              let tickets = Object.values(item.tickets);
              const { username, uid, brand } = item;
              tickets
                .filter((item) => item.time)
                .forEach((item) => {
                  item.username = username;
                  item.uid = uid;
                  item.brand = brand;
                });
              item.tickets = tickets;
            });
            this.setState({
              request_arr,
              selected: false,
              selected_tickets: null,
              request_status: [],
            });
          } else {
            this.setState({
              request_arr: [],
              selected: false,
              selected_tickets: null,
              request_status: [],
            });
          }
        });
      } else {
        this.setState({
          request_arr: [],
          selected: false,
          request: "",
          chatdiv_visible: false,
          request_status: [],
          room_id: "",
        });
      }
    }
  }

  getStatus = (status) => {
    if (status === "waiting") return "waiting";
    if (status === "ok") return "connected";
    if (status === "false") return "disconnected";
  };

  signOut = () => {
    this.props.history.push("/");
  };

  subscribeTasks = (tasks) => {
    this.setState({ brand_tasks: tasks });
  };

  clickRequest = async (item, index) => {
    console.log("clickRequest item", item);
    const { tickets } = item;
    let { request_status, brand_data } = this.state;

    let userData = await Firebase.getUserDatafromUID(item.brand, item.uid);
    if (userData && userData.eco_id) {
      const ecoData = await Firebase.getEcoUserbyId(userData.eco_id);
      userData = { ...userData, ...ecoData };
    }

    this.setState({
      selectedUser: userData,
      request: item,
      selected_tickets: Object.values(tickets),
      clicked: index,
      userIcon: (userData && userData.avatar_url) || null,
    });

    const value = request_status[index];
    request_status = request_status.map((_item) => {
      return false;
    });
    request_status[index] = !value;
    this.setState({ request_status, ticket: false, chatdiv_visible: false });
  };

  clickTicketDetail = (ticket, item, index) => {
    this.setState({
      ticket: ticket,
      ticket_opened: index,
      membername: item.username,
    });
  };

  clickTicket = (ticket, item, index) => {
    const { uid, username } = item;
    const { brand_tasks } = this.state;

    console.log("brand_tasks", brand_tasks);

    const user_tasks = brand_tasks.filter(
      (task) => task.options.user.id === uid
    );
    const { ticket_id, requestFullUpgrade } = ticket;

    let task;
    if (user_tasks.length > 0)
      task = user_tasks.find(
        (task) =>
          task.options.ticket && task.options.ticket.ticket_id === ticket_id
      );

    this.setState({
      ticket_opened: index,
      chatdiv_visible: true,
      room_id: uid,
      ticket: ticket,
      membername: username,
      upcomingTask: task,
      requestFullUpgrade: requestFullUpgrade,
    });
  };

  showRequest = () => {
    const { request_arr, clicked, ticket_opened, request_status, brand_data } =
      this.state;
    return request_arr.map((item, index) => {
      return (
        <Fragment key={index}>
          <RequestItem
            clickRequest={() => this.clickRequest(item, index)}
            brand={brand_data}
            data={item}
            ticket_opened={ticket_opened === index ? true : false}
            clicked={clicked === index && request_status[index] ? true : false}
            clickDetail={(ticket) =>
              this.clickTicketDetail(ticket, item, index)
            }
            clickTicket={(ticket) => this.clickTicket(ticket, item, index)}
          />
        </Fragment>
      );
    });
  };

  showTickets = () => {
    const { selected_tickets } = this.state;
    return selected_tickets.map((item) => {
      return (
        <p key={item.ticket_id}>
          Ticket number&nbsp;:&nbsp;{item.ticket_id} &nbsp;&nbsp;&nbsp;Ticket
          issue&nbsp;:&nbsp;
          {item.issue}
        </p>
      );
    });
  };

  goBack = () => this.props.history.goBack();

  handleChangeBrand = (selectedBrand) => this.setState({ selectedBrand });

  schedule = async (option) => {
    const { selectedUser: user, ticket } = this.state;
    const { brand_name: brand } = this.state;
    const { description, duration, time, title, date } = option;
    const { hh, mm } = time;
    const minutes = hh * 60 + mm;
    let m = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const scheduled_time = m.add(minutes, "minutes");

    let task = {
      brand,
      options: { user, title, description, duration, ticket },
      performAt: scheduled_time.toDate(),
      status: "scheduled",
      worker: "makeCall",
    };
    try {
      await Firebase.addTask(task);
      const { firstname, phonenumber } = user;
      if (phonenumber)
        alertAppointment(
          phonenumber,
          brand,
          firstname,
          getDayStr(scheduled_time.toDate())
        );
      this.addAppointment(scheduled_time.toDate().toString());
    } catch (error) {
      console.log("Schedule appointment error", error);
    }
  };

  addMessage = (message) => {
    let { room_id, ticket } = this.state;
    const { ticket_id } = ticket;
    message.time = Date.now();
    Firebase.addMessage(room_id, ticket_id, message, (res) => {
      if (ticket.status === "Waiting") {
        Firebase.acceptRequest(room_id, ticket_id);
      }
      Firebase.setUnReadMessage(room_id, ticket_id, {
        latest: message.message,
        time: message.time,
        ticket: ticket,
      });
    });
  };

  addAppointment = async (scheduled_time) => {
    let { room_id, ticket, username, membername, brand_name } = this.state;
    let time = new Date().getTime().toString();
    let { note } = await Firebase.getTicketDataOnce(room_id, ticket.ticket_id);
    let notes = note ? note : [];
    notes.push({
      time: time,
      note: `Hi ${membername}, I have created an appointment for us to meet through ${brand_name} chat at ${scheduled_time}.`,
      username: "Bot",
      noteType: "added-appointment",
      noter: username,
      noterId: localStorage.getItem("uid"),
    });
    this.addMessage({
      type: "bot",
      message: `Hi ${membername}, I have created an appointment for us to meet through ${brand_name} chat at ${scheduled_time}.`,
      username: "Bot",
    });
    Firebase.updateTicketNote(room_id, ticket.ticket_id, notes);
  };

  // TODO: complete this function
  requestUserUpgrade = () => {};

  handleClickAttachment = (content) => {
    const { media_type, media_url } = content;
    if (media_type === "pdf_file") this.setState({ selectedPDF: media_url });
  };

  render() {
    const {
      logo,
      is_property_brand,
      chatdiv_visible,
      room_id,
      ticket,
      membername,
      icon,
      loadingBrands,
      selectedBrand,
      brands,
      brand_data,
      request_arr,
      userIcon,
      categories, // TODO: is this used?
      selectedUser,
      fullUserUpgrade, // TODO: is this used?
      requestFullUpgrade,
      selectedPDF,
      users, // TODO: is this used?
      ticketIssues,
      upcomingTask,
    } = this.state;
    const HexButton = HexHover("button", brand_data ? brand_data.hex : "white");
    const { username, role } = this.props.location.state;
    console.log("upcomingTask", upcomingTask);

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          is_property_brand={is_property_brand}
        />
        <div className="super-chatsuite-container">
          {loadingBrands ? (
            <div className="loading">
              <i className="fa fa-3x fa-sync fa-spin text-muted" />
            </div>
          ) : (
            <React.Fragment>
              <div className="header-container">
                <div className="brands-container">
                  <p className="title">Brand Communications</p>
                  <div className="select-container">
                    <Select
                      value={selectedBrand}
                      onChange={this.handleChangeBrand}
                      options={(brands || []).map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                    />
                  </div>
                  <div className="ticket-stats">
                    <p className="open-ticket">
                      Open Tickets: <span>{request_arr.length}</span>
                    </p>
                    {/* FIXME: hid the below stats because they were hard-coded dummy data  */}
                    {/* <p className="closed-ticket">
                    Closed Tickets <span>N/A</span>
                  </p>
                  <p className="happy-users">
                    Happy Users <span>N/A</span>
                  </p> */}
                  </div>
                </div>
                <div className="status-container">
                  {selectedUser && (
                    <Fragment>
                      <div
                        className="avatar"
                        data-toggle="modal"
                        data-target="#manifest_modal"
                        style={{
                          backgroundImage: `url(${
                            selectedUser.avatar_url || user_avatar
                          })`,
                        }}
                      />
                      <p>{selectedUser.firstname}</p>
                      {ticket && (
                        <Fragment>
                          {!selectedUser.phonenumber &&
                            (requestFullUpgrade ? (
                              <p
                                className="color-orange"
                                style={{
                                  fontSize: 15,
                                  marginLeft: 10,
                                  fontWeight: "800",
                                }}
                              >
                                Pending user upgrade
                              </p>
                            ) : (
                              <button
                                className="btn btn-red ml-5"
                                onClick={this.requestUserUpgrade}
                              >
                                Request full user upgrade
                              </button>
                            ))}
                          <HexButton
                            className="btn btn-light text-dark"
                            data-toggle="modal"
                            data-target="#add_note_dialog"
                            style={{ marginLeft: "auto" }}
                          >
                            Add note
                          </HexButton>
                        </Fragment>
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
              <div className="row no-gutters flex-md-10-auto chatsuite-container">
                <div className="col-md-7 col-lg-7 col-xl-7 bg-body-dark side-container left">
                  <div className="content content-full">
                    <div className="block block-fx-pop">
                      {this.showRequest()}
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-5 col-lg-5 col-xl-5"
                  style={{ height: "87%" }} // 104%
                >
                  {/* <div className="content"> */}
                  {/* <div className="d-md-none push">
                    <button
                      type="button"
                      className="btn btn-block btn-hero-primary"
                      data-toggle="class-toggle"
                      data-target="#side-content"
                      data-class="d-none"
                    >
                      Live chat
                    </button>
                  </div> */}

                  {/* <div id="side-content" className="push"> */}
                  {chatdiv_visible ? (
                    <LiveChat
                      room_id={room_id}
                      username={membername}
                      ticket={ticket}
                      icon={icon}
                      userIcon={userIcon}
                      brand={this.state.brand_name}
                      territory={brand_data.territory}
                      comingtask={upcomingTask}
                    />
                  ) : (
                    <div className="empty_chat">
                      <img src={chat_png} alt="chat" />
                      <p style={{ width: "60%" }}>
                        Choose a brand and select a chat ticket or start a new
                        chat, to engage with community members directly.
                      </p>
                    </div>
                  )}
                  {/* </div> */}
                  {/* </div> */}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        {brand_data && ticket && (
          <TicketDetailModal
            brandData={brand_data}
            ticketId={ticket.ticket_id}
            roomId={room_id}
            userIcon={userIcon}
            membername={membername}
            uid={localStorage.getItem("uid")}
            username={username}
            onClickAttachment={this.handleClickAttachment}
            ticketIssues={ticketIssues}
          />
        )}
        <AddNoteModal
          brandData={brand_data}
          roomId={room_id}
          uid={localStorage.getItem("uid")}
          ticket={ticket}
          username={username}
          onChangeProfile={this.handleChangeProfile}
          addTokens={this.addTokens}
        />
        <PDFViewerModal pdfUrl={selectedPDF} />
        {selectedUser && (
          <ManifestModal
            user={selectedUser}
            brandData={brand_data}
            categories={categories}
            onChangeProfile={this.handleSaveManifest}
            onClickTicket={(ticket) => this.setState({ ticket: ticket })}
            onClickAttachment={this.handleClickAttachment}
            ref={this.manifestModalRef}
          />
        )}
        <SelectUserModal users={users} onOpenChat={this.onOpenChat} />
        <ScheduleModal
          users={false}
          isDatePickable={true}
          schedule={this.schedule}
        />
      </div>
    );
  }
}
export default SuperChatSuite;



// WEBPACK FOOTER //
// ./src/screens/SuperChatSuite/index.js